import { ProColumns } from '@ant-design/pro-components';
import { CheckStatus, CloseStatus } from 'base/ui/components/Icons';
import { CustomerGeneral } from 'services/Main/customerGeneralReport_services';

export const defaultColumn: ProColumns<CustomerGeneral>[] = [
  {
    title: 'STT',
    dataIndex: 'stt',
    width: 50,
    align: 'center',
  },
  // Mã CRM
  {
    title: 'Mã CRM',
    dataIndex: 'profileCode',
    align: 'center',
    width: 100,
  },
  // Mã SAP
  {
    title: 'Mã SAP',
    dataIndex: 'profileForeignCode',
    align: 'center',
    width: 100,
  },
  // Tên
  {
    title: 'Tên',
    dataIndex: 'profileName',
    width: 200,
    ellipsis: true
  },
  // Tên ngắn KH
  {
    title: 'Tên ngắn KH',
    dataIndex: 'profileShortName', width: 150,
  },
  // Loại địa chỉ
  {
    title: 'Loại địa chỉ',
    dataIndex: 'addressTypeName3', width: 150,
  },
  // Địa chỉ
  {
    title: 'Địa chỉ',
    dataIndex: 'adcress3', width: 150, ellipsis: true
  },
  // Địa chỉ chính/phụ
  {
    title: 'Địa chỉ chính/phụ',
    dataIndex: 'isMain', width: 150, ellipsis: true
  },
  // Số điện thoại
  {
    title: 'Số điện thoại',
    dataIndex: 'phone', width: 100, ellipsis: true
  },
  // Email
  {
    title: 'Email',
    dataIndex: 'email', width: 100, ellipsis: true
  },
  // Mã số thuế
  {
    title: 'Mã số thuế',
    dataIndex: 'taxNo', width: 100, ellipsis: true
  },
  // Phân loại KH
  {
    title: 'Phân loại KH',
    dataIndex: 'customerTypeName', width: 100, ellipsis: true
  },
  // Nhóm KH
  {
    title: 'Nhóm KH',
    dataIndex: 'customerGroupName', width: 150, ellipsis: true
  },
  // Ngành nghề
  {
    title: 'Ngành nghề',
    dataIndex: 'customerCareerName', width: 150, ellipsis: true
  },
  // Phường/Xã
  {
    title: 'Phường/Xã',
    dataIndex: 'wardName3', width: 150, ellipsis: true
  },
  // Quận/Huyện
  {
    title: 'Quận/Huyện',
    dataIndex: 'districtName3', width: 150, ellipsis: true
  },
  // Tỉnh/Thành phố
  {
    title: 'Tỉnh/Thành phố',
    dataIndex: 'provinceName3', width: 150, ellipsis: true
  },
  // Khu vực
  {
    title: 'Khu vực',
    dataIndex: 'saleOfficeName3', width: 150, ellipsis: true
  },
  // Độ tuổi
  {
    title: 'Độ tuổi',
    dataIndex: 'age', width: 100,
  },
  // Ghi chú
  {
    title: 'Ghi chú',
    dataIndex: 'note', width: 200, ellipsis: true
  },
  // Mã NV KD
  {
    title: 'Mã NV KD',
    dataIndex: 'personInChargeCode', width: 100, ellipsis: true
  },
  // Nhân viên kinh doanh
  {
    title: 'Nhân viên kinh doanh',
    dataIndex: 'personInCharge', width: 150, ellipsis: true
  },
  // Phòng ban NVKD
  {
    title: 'Phòng ban NVKD',
    dataIndex: 'roleInCharge', width: 150, ellipsis: true
  },
  // NV Admin
  {
    title: 'NV Admin',
    dataIndex: 'adminEmployeeName', width: 150, ellipsis: true
  },
  // Phân hạng KH
  {
    title: 'Phân hạng KH',
    dataIndex: 'phanHang', width: 150, ellipsis: true
  },
  // Mã liên hệ(Chính)
  {
    title: 'Mã liên hệ(Chính)',
    dataIndex: 'contactCode', width: 150, ellipsis: true
  },
  // Tên liên hệ
  {
    title: 'Tên liên hệ',
    dataIndex: 'contactName', width: 150, ellipsis: true
  },
  // SĐT liên hệ
  {
    title: 'SĐT liên hệ',
    dataIndex: 'contactPhone', width: 150, ellipsis: true
  },
  // Email liên hệ
  {
    title: 'Email liên hệ',
    dataIndex: 'contactEmail', width: 150, ellipsis: true
  },
  // Chức vụ
  {
    title: 'Chức vụ',
    dataIndex: 'contactPositionName', width: 150, ellipsis: true
  },
  // Bộ phận
  {
    title: 'Bộ phận',
    dataIndex: 'contactDepartmentName', width: 150, ellipsis: true
  },
  // Mã nhân viên TVVL
  {
    title: 'Mã nhân viên TVVL',
    dataIndex: 'personInCharge6Code', width: 150, ellipsis: true
  },
  // Nhân viên TVVL
  {
    title: 'Nhân viên TVVL',
    dataIndex: 'personInCharge6Name', width: 150, ellipsis: true
  },
  // Công ty
  {
    title: 'Công ty',
    dataIndex: 'createAtCompanyName', width: 150, ellipsis: true
  },
  // Thị trường
  {
    title: 'Thị trường',
    dataIndex: 'foreignCustomer', width: 150, ellipsis: true
  },
  // Nguồn khách hàng
  {
    title: 'Nguồn khách hàng',
    dataIndex: 'customerSourceName', width: 150, ellipsis: true
  },
  // Chi nhánh
  {
    title: 'Chi nhánh',
    dataIndex: 'saleOrgName', width: 150, ellipsis: true
  },
  // SĐT 1
  {
    title: 'SĐT 1',
    dataIndex: 'phone1', width: 150, ellipsis: true
  },
  // SĐT 2
  {
    title: 'SĐT 2',
    dataIndex: 'phone2', width: 150, ellipsis: true
  },
  // Ngày sinh
  {
    title: 'Ngày sinh',
    dataIndex: 'dateOfBirth',
    valueType: 'dateTime',
    fieldProps: {
      format: 'DD/MM/YYYY',
    },
    width: 150,
    onCell: (_, index) => ({
      className: 'text-center font-bold',
    }),
  },
  // Ngày thăm hỏi gần nhất
  {
    title: 'Ngày thăm hỏi gần nhất',
    dataIndex: 'closeVisitDate',
    valueType: 'dateTime',
    fieldProps: {
      format: 'DD/MM/YYYY',
    },
    width: 150,
    onCell: (_, index) => ({
      className: 'text-center font-bold',
    }),
  },
  // Trạng thái
  {
    title: 'Trạng thái',
    dataIndex: 'actived', width: 150, ellipsis: true
  },
  // Ngày tạo
  {
    title: 'Ngày tạo',
    dataIndex: 'createTime',
    valueType: 'dateTime',
    fieldProps: {
      format: 'DD/MM/YYYY',
    },
    width: 150,
    onCell: (_, index) => ({
      className: 'text-center font-bold',
    }),
  },
  // Người tạo
  {
    title: 'Người tạo',
    dataIndex: 'createUser', width: 150, ellipsis: true
  },
  // Ngày sinh
  {
    title: 'Ngày sinh',
    dataIndex: 'dateOfBirth',
    valueType: 'dateTime',
    fieldProps: {
      format: 'DD/MM/YYYY',
    },
    width: 150,
    onCell: (_, index) => ({
      className: 'text-center font-bold',
    }),
  },
];